package org.btmonier.games.model

import kotlinx.serialization.Serializable

@Serializable
data class GameMetadata(
    val title: String,
    val slug: String,
    val date: String? = null,
    val tags: List<String> = emptyList(),
    val status: String? = null,
    val technology: String? = null
)
